import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { TFunction } from 'i18next';

import { Container } from '../components/MenuBar';
import NavGroup from '../components/MenuBar/NavGroup';
import { useAccountId } from '../auth/useAccountId';

const MenuInternal = (
    {
        t,
        accountId,
    }: {
        t: TFunction;
        accountId: string;
    }
) => (<Container>
    <NavGroup
        mainLink={{
            path: `/${accountId}/reports/reports`,
            label: t('reports.menu.reportList'),
        }}
        subLinks={[]}
    />
    <NavGroup
        mainLink={{
            path: `/${accountId}/reports/settlements`,
            label: t('payments.menu.payouts'),
        }}
        subLinks={[]}
    />
</Container>);

const MenuInternalMemo = memo(MenuInternal);

const Menu = () => {
    const { t } = useTranslation();
    const accountId = useAccountId();
    return <MenuInternalMemo t={t} accountId={accountId} />;
};

export default Menu;
